import { render } from "./StatsHeaderSection.vue?vue&type=template&id=899a8cd2"
import script from "./StatsHeaderSection.vue?vue&type=script&lang=js"
export * from "./StatsHeaderSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__